import type {History} from 'history'
import {createBrowserHistory} from 'history'

/**
 * Separate from `~/redux/store` so that `~/routing/navigate`, which the API layer can reach,
 * doesn't drag in the reducer tree.
 *
 * Created on first use, not at module load: `createBrowserHistory` throws without a DOM, which
 * would bar this module from any non-DOM test's import graph.
 */
let instance: History | undefined = undefined

export const getHistory = (): History => (instance ??= createBrowserHistory({}))
